import {
  Box, Flex,Text, Grid, GridItem, Image, Input, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Spinner, Center, Select
} from "@chakra-ui/react"; import MyDiv from './regularizationSetting.style';
import { CustomButton, CustomToast, ActionEditIcon } from '../../../../components';
import { useEffect, useState } from 'react';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { IBranchDropdown, ICompanyDropdown, IDepartment, IRegularizationSetting } from './modal';
import { useFetch } from "../../../../hooks/useFetch";
import CustomTables, { Column, ILazyParams as ICustomTableLazyParams } from '../../../../components/CustomTable/CustomTables';


const RegularizationSetting = () => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [regularization, setRegularization] = useState<IRegularizationSetting[]>([]);
  const [companyDropdown, setCompanyDropdown] = useState<ICompanyDropdown[]>([]);
  const [branch, setBranch] = useState<IBranchDropdown[]>([]);
  const [department, setDepartment] = useState<IDepartment[]>([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [lazyParams, setLazyParams] = useState<ICustomTableLazyParams>({ first: 0, rows: 20, sortField: undefined, sortOrder: undefined, multiSortMeta: [], filters: {}, globalFilter: "", });


  const [formData, setFormData] = useState({
    company_ID: '',
    branch_Id: '',
    department_Id: '',
    max_Req_Number: '',
  });


  useEffect(() => {
    loadRegularization();
  }, [lazyParams]);

  useEffect(() => {
    loadCompanyDropdown();
    departmentData();
  }, []);

  const loadCompanyDropdown = async () => {
    const response = await fetchApi<ICompanyDropdown[]>('Dropdown/company', 'GET');
    if (response) setCompanyDropdown(response);
  };

  const branchData = async (companyID?: number) => {
    const response = await fetchApi<IBranchDropdown[]>("DropDown/branches", "GET", "", companyID ? `companyId=${companyID}` : null);
    if (response) setBranch(response);
  };

  const departmentData = async () => {
    const response = await fetchApi<IDepartment[]>("DropDown/department", "GET");
    if (response) setDepartment(response);
  };

  const loadRegularization = async () => {
    setLoading(true);

    try {
      const params = new URLSearchParams();

      params.set("first", String(lazyParams.first));
      params.set("rows", String(lazyParams.rows));

      if (lazyParams.sortField) {
        params.set("sortField", lazyParams.sortField);
      }

      if (lazyParams.sortOrder) {
        params.set("sortOrder", String(lazyParams.sortOrder));
      }

      if (lazyParams.globalFilter) {
        params.set("globalFilter", lazyParams.globalFilter);
      }

      if (
        lazyParams.filters &&
        Object.keys(lazyParams.filters).length > 0
      ) {
        params.set("filters", JSON.stringify(lazyParams.filters));
      }

      const response = await fetchApi(
        `Regularization/RegularizationSetting?${params.toString()}`, "GET");

      if (response) {
        setRegularization(
          response.data ?? response.regularization ?? []
        );

        setTotalCount(
          response.totalCount ??
          response.totalRecords ??
          0
        );
      }
    } catch (error) {
      console.error("Failed to load regularization:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleAddNew = () => {
    setIsEditMode(false);
    setSelectedId(null);
    setFormData({
      company_ID: '',
      branch_Id: '',
      department_Id: '',
      max_Req_Number: '',
    });
    setDrawerOpen(true);
  };

  const handleEdit = (item: IRegularizationSetting) => {
    setIsEditMode(true);
    setSelectedId(item.id);
    setFormData({
      company_ID: String(item.company_ID),
      branch_Id: String(item.branch_Id),
      department_Id: String(item.department_Id),
      max_Req_Number: String(item.max_Req_Number),
    });
    branchData(item.company_ID);
    setDrawerOpen(true);
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (name === "company_ID") {
      setFormData(prev => ({ ...prev, branch_Id: "" }));
      setBranch([]);
      branchData(Number(value));
    }
  };

  const handleSubmit = async () => {

    if (!formData.company_ID) {
      addToast({ message: "Please select a company.", status: "warning" });
      return;
    }

    if (!formData.branch_Id) {
      addToast({ message: "Please select a branch.", status: "warning" });
      return;
    }

    if (!formData.department_Id) {
      addToast({ message: "Please select a department.", status: "warning" });
      return;
    }

    if (!formData.max_Req_Number) {
      addToast({ message: "Please enter the maximum number of requests per month.", status: "warning" });
      return;
    }
    setLoading(true);
    const payload = {
      branch_Id: Number(formData.branch_Id),
      department_Id: Number(formData.department_Id),
      max_req_Number: Number(formData.max_Req_Number),
    };

    if (isEditMode && selectedId) {
      const response = await fetchApi(`Regularization/RegularizationSetting/${selectedId}`, "PUT", payload, null, "Regularization Setting updated successfully");
      if (response) {
        loadRegularization();
        setDrawerOpen(false);
      }
    } else {
      const response = await fetchApi("Regularization/RegularizationSetting", "POST", payload, null, "Regularization Setting added successfully");
      if (response) {
        loadRegularization();
        setDrawerOpen(false);
      }
    }
    setLoading(false);
  };

  return (
    <MyDiv>
      <Box position="relative" minH="300px">
        {loading ? (
          <Center position="absolute" top={0} left={0} right={0} bottom={0}>
            <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
          </Center>
        ) : (
          <>
            <Flex className="page_heading flex_header" justify="space-between">
              <Text className="font-poppins text_semibold text_3xl">Regularization Setting</Text>
              <CustomButton title="Add New Regularization Setting" className="btn font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} className="logo" />} onClick={handleAddNew} />
            </Flex>

            <Grid className="grid_container">
              <GridItem colSpan={12}>
                <CustomTables<IRegularizationSetting>
                  value={regularization} loading={loading} emptyMessage="No Regularization Setting Available" preferenceKey="regularizationSettingTable" showToolbar={true}
                  showGlobalSearch={false} lazy lazyParams={lazyParams} onLazyParamsChange={setLazyParams} totalRecords={totalCount}
                  showPagination rowsPerPageOptions={[20, 50, 100, 500]} maxTableHeight={null}
                >
                  <Column header="S. No" body={(_: any, index: number) => lazyParams.first + index + 1 } />
                  <Column header="Company" field="company_Name" sortable filterable filterType="text" />
                  <Column header="Branch" field="branch_Name" sortable filterable filterType="text"/>
                  <Column header="Department" field="department_Name" sortable filterable filterType="text" />
                  <Column header="Max Requested No./Monthly" field="max_Req_Number" sortable filterable filterType="number" />
                  <Column header="Action" frozen="right" body={(row: IRegularizationSetting) => ( <ActionEditIcon  onClick={() => handleEdit(row)}  /> )}
                  />
                </CustomTables>
              </GridItem>
            </Grid>

            <Drawer isOpen={drawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
              <DrawerOverlay />
              <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader borderBottomWidth="1px">
                  {isEditMode ? 'Edit Regularization Setting' : 'Add Regularization Setting'}
                </DrawerHeader>
                <DrawerBody position="relative" paddingBottom="80px">
                  <FormControl mb={3}>
                    <FormLabel>Company Name</FormLabel>
                    <Select name="company_ID" value={formData.company_ID} onChange={handleInputChange} placeholder="Select Company" >
                      {companyDropdown.map(comp => (
                        <option key={comp.company_ID} value={comp.company_ID}>
                          {comp.company_Name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl mb={3}>
                    <FormLabel>Branch Name</FormLabel>
                    <Select name="branch_Id" value={formData.branch_Id} onChange={handleInputChange} placeholder="Select Branch" isDisabled={!branch.length}>
                      {branch.map(b => (
                        <option key={b.branch_Id} value={b.branch_Id}>
                          {b.branchName}
                        </option>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl mb={3}>
                    <FormLabel>Department Name</FormLabel>
                    <Select name="department_Id" value={formData.department_Id} onChange={handleInputChange} placeholder="Select Department" isDisabled={!department.length} >
                      {department.map(d => (
                        <option key={d.id} value={d.id}>
                          {d.departmentName}
                        </option>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl mb={3}>
                    <FormLabel>Max Requested No./Month</FormLabel>
                    <Input type="number" name="max_Req_Number" value={formData.max_Req_Number} onChange={handleInputChange} placeholder="Enter max requested No" />
                  </FormControl>
                  <Flex position="absolute" bottom="20px" right="20px" gap={2} mt={4} >
                    <Button onClick={() => setDrawerOpen(false)} bg="#D92F34" color="white">Cancel</Button>
                    <Button onClick={handleSubmit} bg="#006838" color="white">{isEditMode ? "Update" : "Add"}</Button>
                  </Flex>
                </DrawerBody>
              </DrawerContent>
            </Drawer>
          </>
        )}
      </Box>
    </MyDiv>
  );
};

export default RegularizationSetting;
